export default async (context) => {
    context.select = 'no-shooting'

    await context.$store.dispatch('survey_price/setSelectSurveyPrice', {
        price: 0
    })

    await context.$store.dispatch('survey_price/setSelectSurveyName', {
        name: 'Без съемки'
    })

    context.$router.push('/final')
}